/**
 * Checks if a walkthrough should be shown based on its ID.
 *
 * @param {String} walkthroughID The ID of the walkthrough
 * @return {Boolean} True if the walkthrough should be shown, false otherwise
 * @throws {Error} If the walkthroughID is missing or invalid
 */
const shouldShowWalkthrough = ( walkthroughID ) => {
	if ( ! walkthroughID || typeof walkthroughID !== 'string' ) {
		throw new Error( 'Invalid or missing walkthroughID' );
	}

	const walkthroughs = UncannyAutomator._site.walkthroughs;

	// In case array is empty we don't want to stop the entire recipe from running.
	if ( ! walkthroughs || walkthroughs.length === 0 ) {
		return false;
	}

	const walkthrough = walkthroughs[walkthroughID];

	if ( ! walkthrough ) {
		throw new Error( `Walkthrough with ID ${ walkthroughID } does not exist` );
	}

	return walkthrough.show;
}

export default shouldShowWalkthrough;
